"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmsModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../Button/Button");
var _SmsModalModule = _interopRequireDefault(require("./SmsModal.module.css"));
var _modal = require("../assets/icons/modal");
var _excluded = ["error", "onSuccess", "onCancel"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SmsModal = function SmsModal(_ref) {
  var error = _ref.error,
    onSuccess = _ref.onSuccess,
    onCancel = _ref.onCancel,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, _extends({
    onHide: onCancel,
    contentClassName: _SmsModalModule.default.modal
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: _SmsModalModule.default.header,
    closeButton: true,
    closeVariant: 'white'
  }, /*#__PURE__*/_react.default.createElement("h1", null, "\u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8 SMS \u10D9\u10DD\u10D3\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: _SmsModalModule.default.body
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    className: _SmsModalModule.default.form,
    noValidate: true,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log(e.target.sms.value);
      //onSuccess(e.target.sms.value)
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _SmsModalModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    style: {
      color: error ? 'var(--bs-danger)' : 'inherit',
      marginBottom: '1.5rem'
    }
  }, error ? error : 'გთხოვთ, მიუთითეთ თქვენს ნომერზე გამოგზავნილი SMS კოდი'), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: 'number',
    autoComplete: 'off',
    isInvalid: !!error,
    name: 'sms'
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    gap: 4,
    style: {
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'success',
    type: 'submit'
  }, "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'secondary',
    onClick: onCancel
  }, "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0")))));
};
exports.SmsModal = SmsModal;
SmsModal.propTypes = {
  show: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  message: _propTypes.default.string,
  onSuccess: _propTypes.default.func,
  onCancel: _propTypes.default.func
};
SmsModal.defaultProps = {
  show: true,
  centered: true
};